<div class="main-container">
    <h3 class="global-title">
        Partner contact
    </h3>
    <div *ngFor="let contactForm of contactForms">
        <div [formGroup]="contactForm" class="contact-form">
            <div class="contact-form-item-container">
                <div>
                    <p>
                        Type
                    </p>
                    <p-dropdown placeholder="---" [options]="schoolService.schoolContactTypes" formControlName="contactType"
                        optionLabel="name"></p-dropdown>
                </div>
                <div>
                    <p>
                        Name
                    </p>
                    <input pInputText formControlName="name">
                </div>
            </div>
            <div class="contact-form-item-container">
                <div>
                    <p>
                        Email
                    </p>
                    <input pInputText formControlName="email" width="380">
                </div>
                <div>
                    <p>
                        Phone number
                    </p>
                    <input pInputText formControlName="phoneNumber">
                </div>
            </div>
        </div>
        <div class="delete-button-container">
            <p-button styleClass="p-button-danger" label="Delete" (onClick)="deleteContact(contactForm)" [disabled]="schoolService.selectedSchool.isDeleted"></p-button>
        </div>
    </div>
    <div>
        <p-button label="Add Contact" (onClick)="addContactForm()" [disabled]="schoolService.selectedSchool.isDeleted"></p-button>
    </div>
</div>